import { getVisaPayConfirmData } from '@/src/api/services/visaService'
import { RootState } from '@/src/store'
import { VisaPayConfirmationData } from '@/src/types/visa/visaConfirmationType'
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: VisaPayConfirmationData = {
    isLoading: true,
    payDetails: {
        itineraryId: '',
        tripId: '',
        bookingId: '',
        searchCriteria: {
            countryCode: '',
            visaCategory: null,
            dateOfVisa: '',
            paxInfo: {
                adults: 0,
                children: 0
            }
        },
        travellerDetails: {
            personalDetails: {
                lastName: ''
            }
        },
        totalFareComponent: {
            totalAmount: 0,
            currencyCode: ''
        },
        transactionId: '',
        destinationCountry: '',
        reservationRef: ''
    }
}

export const fetchVisaPayDetails = createAsyncThunk(
    'visaPayConfirm/fetchVisaPayDetails',
    async (itineraryId: string) => {
        const response = await getVisaPayConfirmData(itineraryId)
        return response as VisaPayConfirmationData
    }
)

const visaPayConfirmSlice = createSlice({
    name: 'visaPayConfirm',
    initialState,
    reducers: {
        setVisaPayDetails: (state, action) => {
            state.payDetails = action.payload
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload
        }
    },
    extraReducers(builder) {
        builder.addCase(fetchVisaPayDetails.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(
            fetchVisaPayDetails.fulfilled,
            (state, action: { payload: any }) => {
                state.isLoading = false
                state.payDetails = action.payload
            }
        )
        builder.addCase(fetchVisaPayDetails.rejected, (state) => {
            state.isLoading = false
        })
    }
})

export const { setVisaPayDetails, setLoading } = visaPayConfirmSlice.actions
export const getVisaPayConfirmState = (state: RootState) => state.visaPayDetails
export default visaPayConfirmSlice.reducer
